import type { PluginWebManifest } from '@reflex/plugin-api/web';

/** Agent-tab id. Shared with the chat card, which deep-links to this tab. */
export const WORK_ASSESSMENT_TAB_ID = 'work-assessment';

export const workAssessmentWeb: PluginWebManifest = {
  // A no-page plugin: everything it contributes hangs off an agent. The
  // overview card is hand-written (rather than via `definePage`, which would
  // mint an unwanted route and nav item) so the plugin detail page still
  // renders a rich About section, and `to` targets that detail page since
  // there is no standalone page to deep-link to.
  overviewCards: [
    {
      to: '/org/plugins/work-assessment',
      label: 'Work Assessment',
      icon: 'ClipboardCheck',
      description: 'Structured, reviewable walkthroughs of what an agent actually did.',
      details:
        'Ask an agent to assess a body of work — its own changes in the run, or a pull request you point it at — and it writes the PR overview you wish every PR had: what the work set out to do, the approach it chose, the decisions that actually mattered, and a reading order for reviewing it quickly. The assessment posts to the chat and opens full-screen in the Assessment tab, with clickable file paths, syntax-highlighted code, and mermaid diagrams. Every gap it reports can be sent straight back to the agent or handed to a fresh one, with your comments attached.',
      features: [
        '"Assessment" tab on every agent detail page',
        'Intent and approach up front, then a top-down walkthrough',
        'The decisions that mattered, with the alternatives that lost',
        'A reading order for reviewing the change quickly',
        'Pick the gaps worth closing, comment on each, and send them back',
        'Or launch a follow-up agent on them, in the same repo and blueprint',
        'Clickable absolute file paths that open in the file preview',
        'Markdown, syntax highlighting, mermaid diagrams, and link unfurls',
        'Start one from the tab or the chat @ menu',
      ],
      group: 'plugins',
    },
  ],
  agentTabs: [
    {
      id: WORK_ASSESSMENT_TAB_ID,
      label: 'Assessment',
      icon: 'ClipboardCheck',
      componentPath: '@reflex/plugin-work-assessment/web/WorkAssessmentTab',
    },
  ],
  // "Start assessment" in a running agent's `@` menu. Posts the same request
  // the tab's button does, so the two entry points can't drift.
  chatMentionProviders: [
    {
      id: 'work-assessment-start',
      label: 'Assessment',
      icon: 'ClipboardCheck',
      componentPath: '@reflex/plugin-work-assessment/web/StartAssessmentMentionProvider',
    },
  ],
  marketingPreviews: [
    {
      id: 'work-assessment-panel',
      label: 'Assessment agent panel',
      description:
        'The "Assessment" tab that appears on every agent — a sample walkthrough with its intent, approach, decisions, and review order.',
      surface: 'panel',
      componentPath: '@reflex/plugin-work-assessment/web/WorkAssessmentTabPreview',
    },
  ],
};
